(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const shoppingKey = 'lmd-last-shopping-page';
  const editKey = 'lmd-cart-edit-context';
  const normalize = value => Object.fromEntries(Array.isArray(value) ? value : Object.entries(value || {}));
  function getStored(key) {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; }
  }
  function store(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; }
  }
  if (/\/(products|collections|search)(\/|$)/.test(location.pathname)) {
    store(shoppingKey, { url: location.pathname + location.search, y: scrollY });
    addEventListener('pagehide', () => store(shoppingKey, { url: location.pathname + location.search, y: scrollY }));
  }
  function shoppingUrl() {
    const saved = getStored(shoppingKey);
    if (!saved?.url) return root + 'collections/all';
    const target = new URL(saved.url, location.origin);
    return target.origin === location.origin && /\/(products|collections|search)(\/|$)/.test(target.pathname) ? target.pathname + target.search : root + 'collections/all';
  }
  let recommendations;
  let recommendationsAnchor;
  const mobileCart = matchMedia('(max-width: 989px)');
  function positionRecommendations() {
    const footer = document.querySelector('#main-cart-footer')?.closest('.shopify-section');
    if (!footer) return;
    if (!recommendations?.isConnected) {
      const offer = document.querySelector('cart-items > .page-width > div > [data-essential-upsell-element="container"]');
      if (!offer) return;
      recommendations = offer.parentElement;
      recommendationsAnchor = document.createComment('cart recommendations position');
      recommendations.before(recommendationsAnchor);
    }
    if (mobileCart.matches && recommendations.previousElementSibling !== footer) {
      recommendations.classList.add('lmd-cart-page-recommendations');
      footer.after(recommendations);
    } else if (!mobileCart.matches && recommendationsAnchor?.isConnected && recommendations.previousSibling !== recommendationsAnchor) {
      recommendations.classList.remove('lmd-cart-page-recommendations');
      recommendationsAnchor.after(recommendations);
    }
  }
  mobileCart.addEventListener('change', positionRecommendations);
  function prepareLinks() {
    positionRecommendations();
    for (const link of document.querySelectorAll('[data-lmd-continue-page]')) {
      const next = shoppingUrl();
      if (link.getAttribute('href') !== next) link.setAttribute('href', next);
    }
    const count = document.querySelectorAll('[data-lmd-cart-count],#CartDrawer .lmd-cart-count');
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    if (bubble) {
      const value = '(' + bubble.textContent.trim() + ')';
      count.forEach(node => { if (node.textContent !== value) node.textContent = value; });
    }
  }
  let stickyBar;
  let stickyFrame = false;
  function updateStickyCheckout() {
    const original = document.querySelector('#main-cart-footer #checkout');
    const total = document.querySelector('#main-cart-footer .totals');
    if (!original || !total) { if (stickyBar) stickyBar.hidden = true; return; }
    if (!stickyBar) {
      stickyBar = document.createElement('div');
      stickyBar.className = 'lmd-cart-sticky-checkout';
      stickyBar.hidden = true;
      const price = document.createElement('div');
      price.className = 'lmd-cart-sticky-total';
      const action = document.createElement('button');
      action.type = 'button';
      action.className = 'button';
      action.addEventListener('click', () => {
        const checkout = document.querySelector('#main-cart-footer #checkout');
        if (checkout && !checkout.disabled && checkout.getAttribute('aria-disabled') !== 'true' && !document.querySelector('.cart__items--disabled,lmd-cart-promo[aria-busy="true"]')) checkout.click();
      });
      stickyBar.append(price, action);
      document.body.append(stickyBar);
    }
    const price = stickyBar.querySelector('.lmd-cart-sticky-total');
    const amount = total.innerText.trim().replace(/\s+/g, ' ');
    if (price.textContent !== amount) price.textContent = amount;
    const action = stickyBar.querySelector('button');
    const label = original.textContent.trim();
    if (action.textContent !== label) action.textContent = label;
    const disabled = original.disabled || original.getAttribute('aria-disabled') === 'true' || !!document.querySelector('.cart__items--disabled,lmd-cart-promo[aria-busy="true"]');
    if (action.disabled !== disabled) action.disabled = disabled;
    const rect = original.getBoundingClientRect();
    const viewportHeight = window.visualViewport?.height || innerHeight;
    const visible = rect.top < viewportHeight && rect.bottom > 0;
    const typing = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
    const mobile = matchMedia('(max-width: 749px)').matches;
    const empty = document.querySelector('#main-cart-footer')?.classList.contains('is-empty');
    const show = mobile && !empty && !visible && !typing && !document.querySelector('cart-drawer.active') && innerHeight - viewportHeight < 150;
    if (stickyBar.hidden === show) stickyBar.hidden = !show;
    document.body.classList.toggle('lmd-has-sticky-cart', mobile && !empty);
  }
  function scheduleStickyCheckout() {
    if (stickyFrame) return;
    stickyFrame = true;
    requestAnimationFrame(() => { stickyFrame = false; updateStickyCheckout(); });
  }
  addEventListener('scroll', scheduleStickyCheckout, { passive: true });
  addEventListener('resize', scheduleStickyCheckout);
  document.addEventListener('focusin', scheduleStickyCheckout);
  document.addEventListener('focusout', scheduleStickyCheckout);
  window.visualViewport?.addEventListener('resize', scheduleStickyCheckout);
  new MutationObserver(scheduleStickyCheckout).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled','aria-disabled','aria-busy','class'] });
  scheduleStickyCheckout();
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; prepareLinks(); });
  }).observe(document.body, { childList: true, subtree: true });
  prepareLinks();
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-lmd-continue-drawer]');
    if (close) { event.preventDefault(); close.closest('cart-drawer')?.close(); return; }
    const edit = event.target.closest('[data-lmd-edit]');
    if (!edit || event.metaKey || event.ctrlKey || event.shiftKey || event.button) return;
    const row = edit.closest('[data-line-key]');
    if (!row) return;
    const context = {
      identity: { variantId: Number(row.dataset.lineVariant), properties: normalize(JSON.parse(row.dataset.lineProperties || '{}')), sellingPlan: Number(row.dataset.linePlan) || null },
      quantity: Number(row.querySelector('.quantity__input')?.value || row.dataset.lineQuantity),
      url: edit.getAttribute('href'), notice: edit.dataset.editLabel, cancel: edit.dataset.editCancel, failure: edit.dataset.editFailure, save: edit.dataset.editSave,
      created: Date.now()
    };
    if (!store(editKey, context)) { event.preventDefault(); return; }
    const target = new URL(edit.href);
    target.searchParams.set('lmd_edit', '1');
    edit.href = target.pathname + target.search;
  });
  const editing = new URLSearchParams(location.search).get('lmd_edit') === '1' && getStored(editKey);
  if (!editing || Date.now() - editing.created > 1800000 || new URL(editing.url, location.origin).pathname !== location.pathname) return;
  let editingReady = false;
  const protect = event => {
    const form = event.target.closest('product-form');
    if (form && !editingReady && (event.type === 'submit' || event.target.closest('[name="add"]'))) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  };
  document.addEventListener('submit', protect, true);
  document.addEventListener('click', protect, true);
  let attempts = 0;
  const timer = setInterval(async () => {
    const message = document.getElementById('lmd-message');
    const options = document.querySelector('.tpo_option-set-container');
    const size = options?.querySelector('[name="properties[Taille]"]');
    const colour = options?.querySelector('[name="properties[Couleur]"]');
    const coloursReady = colour?.closest('.tpo_option-container')?.querySelectorAll('input[type="radio"]').length;
    const cart = document.querySelector('cart-drawer');
    if (!message || !size || !coloursReady || !cart?.renderContents || !window.LMDMergedCart) { if (++attempts > 100) clearInterval(timer); return; }
    clearInterval(timer);
    const props = editing.identity.properties;
    const notice = document.createElement('div');
    notice.className = 'lmd-edit-notice';

    const copy = document.createElement('p');
    copy.textContent = editing.notice;
    const cancel = document.createElement('a');
    cancel.href = root + 'cart'; cancel.textContent = editing.cancel;
    cancel.addEventListener('click', () => { try { sessionStorage.removeItem(editKey); } catch (_) {} });
    notice.append(copy, cancel);
    message.closest('.shopify-app-block').prepend(notice);
    const settle = () => new Promise(resolve => setTimeout(resolve, 300));
    const exactMessage = Object.entries(props).find(([key]) => /mot doux|message/i.test(key) && !key.startsWith('_'))?.[1];
    if (exactMessage !== undefined) { message.value = exactMessage; message.dispatchEvent(new Event('input', { bubbles: true })); }
    await settle();
    for (const name of ['Taille', 'Plaqué', 'Couleur']) {
      const desired = props[name];
      if (!desired) continue;
      const field = document.querySelector('[name="properties[' + name + ']"]');
      const container = field?.closest('.tpo_option-container');
      if (!container) continue;
      if (field.classList.contains('tpo_option-dropdown')) {
        const choice = [...container.querySelectorAll('.tpo_option-type-selection')].find(button => button.querySelector('.tpo_option_type_label')?.textContent.trim() === desired);
        if (choice && field.value !== desired) { field.click(); choice.click(); }
      } else {
        const radio = [...container.querySelectorAll('input[type="radio"]')].find(control => control.value === desired);
        if (radio && !radio.checked) {
          radio.click();
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          radio.dispatchEvent(new Event('input', { bubbles: true }));
          field.value = desired;
          field.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      await settle();
    }
    const card = document.querySelector('.tpo_option-set-container #Options-0');
    if (card && card.checked !== Boolean(props.Options)) card.click();
    await settle();
    const form = document.querySelector('product-form form');
    form.querySelector('[name="add"]').dataset.lmdActionLabel = editing.save;
    const quantity = document.querySelector('[name="quantity"][form="' + form.id + '"]') || form.querySelector('[name="quantity"]');
    if (quantity) { quantity.value = editing.quantity; quantity.dispatchEvent(new Event('change', { bubbles: true })); }
    else {
      const input = document.createElement('input'); input.type = 'hidden'; input.name = 'quantity'; input.value = editing.quantity; form.append(input);
    }
    editingReady = true;
    const nativeRender = cart.renderContents.bind(cart);
    let saving = false;
    cart.renderContents = async response => {
      if (saving) return;
      saving = true;
      try {
        const fresh = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(result => { if (!result.ok) throw new Error(); return result.json(); });
        const matching = fresh.items.filter(item => window.LMDMergedCart.matches(item, editing.identity));
        if (matching.length) {
          const added = (response.items || [response]).some(item => window.LMDMergedCart.matches({ ...item, variant_id: item.variant_id || item.id }, editing.identity));
          const result = await window.LMDMergedCart.update(editing.identity, added ? editing.quantity : 0, ['cart-drawer', 'cart-icon-bubble']);
          if (!result.ok) throw new Error();
          const payload = await result.json();
          if (payload.errors) throw new Error();
        }
        sessionStorage.removeItem(editKey);
        location.assign(root + 'cart');
      } catch (_) {
        saving = false;
        copy.textContent = editing.failure; copy.setAttribute('role', 'alert');
        await nativeRender(response);
      }
    };
  }, 150);
})();
